
import { mapGetters } from 'vuex';

import { getBaseUrlByBrand, PROJECT_BRANDS } from '@/modules/brand/domain/brand';
import { Helpers } from '@/services/helpers';

export default {
  props: {
    isDark: {
      type: Boolean,
      default: false,
    },
    sliders: {
      type: Boolean,
      default: false,
    },
    brand: {
      type: String,
      default: PROJECT_BRANDS.reverse,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters('common', ['getIsMembersArea']),

    availableLocales() {
      return this.$i18n.locales.filter((i) => i.code !== this.$i18n.locale);
    },
    loggedin() {
      return Helpers.loggedin();
    },
    isNewTours: () => false,
    isBodyNutritionTour: () => false,
    isWeightLossMonthlyTour: () => false,
    isNutritionWeeklyStartTour: () => false,
    isNutritionKetoTour: () => false,
    shouldReplicateWeightLossMonthlyTour: () => false,
    isSomaticYogaTour: () => false,
    isSomaticExercisesTour: () => false,
    isYogaTour: () => false,
    isPilatesTour: () => false,
    isRHWalkingTour: () => false,
    isNutritionFastingTour: () => false,
    isBodyNutritionButton: () => false,
    homeUrl() {
      return 'home';
    },
    getHamBurgerIcon() {
      return 'icon-hamburger-menu';
    },
    coloredHeader() {
      return false;
    },
    showBurgerMenu() {
      return this.brand === PROJECT_BRANDS.reverse;
    },
    // To do: this is a V1 iteration to have something functional. We need to find a better way to handle multibranding.
    aboutUsUrl() {
      return this.$getUrl('our-cause');
    },
    helpCenterUrl() {
      return this.$getHelpCenterUrl();
    },
    homeLogoUrl() {
      return getBaseUrlByBrand(this.$getBrand());
    },
    hamburgerAriaLabel() {
      return this.isOpen ? this.$t('mainHeader.hamburgerMenu.closeMenu') : this.$t('mainHeader.hamburgerMenu.openMenu');
    },
  },
  watch: {
    $route() {
      this.isOpen = false;
    },
  },
  methods: {
    navigationHandler() {
      this.isOpen = !this.isOpen;
    },
    logout() {
      Helpers.logout();
      window.location.href = this.$getUrl('home');
    },
    handleDefaultState() {
      this.$router.push('/login');
    },
  },
};
